import React from 'react';
import {Link, useLocation} from 'react-router-dom';

import {Box, IconButton, Tooltip} from '@mui/material';
import ViewWeekOutlinedIcon from '@mui/icons-material/ViewWeekOutlined';

import Logo from '../../../assets/logo/logo-full.svg';

export default function Header({ isMiddleSideBar, onToggleSideBar }) {
    const location = useLocation();
    const logoTarget = location.pathname.startsWith('/idea') ? '/idea' : '/chat';

    const tooltipTitle = isMiddleSideBar ? '사이드바 닫기' : '사이드바 열기';

    return (
        <Box
            sx={{
                width: '100%',
                height: '60px',
                px: '10px',
                py: '12px',
                boxSizing: 'border-box',
                display: 'flex',
                alignItems: 'center',
                justifyContent: isMiddleSideBar ? 'space-between' : 'center'
            }}
        >
            {isMiddleSideBar
                ? <Box
                    component={Link}
                    to={logoTarget}
                    sx={{ ml: '8px', display: 'inline-flex', alignItems: 'center' }}
                >
                    <Box component='img' src={Logo} alt='Logo' sx={{ width: '100px', height: '18px', display: 'block' }} />
                </Box>
                : null
            }

            <Tooltip title={tooltipTitle} placement='right' direction='none'>
                <IconButton size='medium' color='default' onClick={onToggleSideBar}>
                    <ViewWeekOutlinedIcon />
                </IconButton>
            </Tooltip>
        </Box>
    );
}
